export default "__VITE_ASSET__DunrkSSs__"